import { docEntityBaseNew } from "building-types/entities/docEntityBaseNew";
import type {
  BoardProfileEntity,
  CustomProfileEntity,
  ProfileEntity,
} from "building-types/entities/profileEntityTypes";
import type {
  BoardDescriptor,
  CustomDescriptor,
  ProfileExtrusionDescriptor,
  ProfileTable,
} from "building-types/profiles/profileTypes";
import { ProfileExtrusionDescriptorType } from "building-types/profiles/profileTypesEnum";
import { ViewEntityType } from "building-types/views/viewEntityType";
import { stripDocEntityBaseFields } from "../entity/docEntityBaseTools";

export function boardDescriptorNew(fields?: Partial<BoardDescriptor>): BoardDescriptor {
  return {
    catalogItemType: "PROFILE_EXTRUSION_DESCRIPTOR",
    name: "A New Rectangular Profile",
    entityType: ViewEntityType.PROFILE_EXTRUSION,
    profileType: ProfileExtrusionDescriptorType.BOARD,
    width: 1.5,
    height: 3.5,
    nominalWidth: 2,
    nominalHeight: 4,
    elevationNoteEnabled: false,
    elevationNote: '4"',
    ...fields,
  };
}

export function customDescriptorNew(fields?: Partial<CustomDescriptor>): CustomDescriptor {
  return {
    catalogItemType: "PROFILE_EXTRUSION_DESCRIPTOR",
    name: "A New Custom Profile",
    entityType: ViewEntityType.PROFILE_EXTRUSION,
    profileType: ProfileExtrusionDescriptorType.CUSTOM,
    polyline: [0, 0, 0, 0.5, 1, 0.5, 1, -0.5, 0, -0.5, 0, 0],
    elevationNoteEnabled: false,
    elevationNote: "",
    ...fields,
  };
}

export function boardProfileEntityNew(fields?: Partial<BoardProfileEntity>): BoardProfileEntity {
  const { catalogItemType, entityType, ...boardDefaults } = boardDescriptorNew();
  void catalogItemType;
  void entityType;
  return {
    ...docEntityBaseNew("PROFILE"),
    ...boardDefaults,
    ...fields,
  };
}

export function customProfileEntityNew(fields?: Partial<CustomProfileEntity>): CustomProfileEntity {
  const { catalogItemType, entityType, ...customDefaults } = customDescriptorNew();
  void catalogItemType;
  void entityType;
  return {
    ...docEntityBaseNew("PROFILE"),
    ...customDefaults,
    ...fields,
  };
}

export function profileEntityToDescriptor(profile: ProfileEntity): ProfileExtrusionDescriptor {
  return {
    ...stripDocEntityBaseFields(profile),
    catalogItemType: "PROFILE_EXTRUSION_DESCRIPTOR",
    entityType: ViewEntityType.PROFILE_EXTRUSION,
  } as ProfileExtrusionDescriptor;
}

/**
 * TEMP SCAFFOLDING: to be removed when we no longer support catalog-only profiles.
 */
export function profileEntitiesToProfileTable(profiles: Record<string, ProfileEntity>): ProfileTable {
  const profileTable: Record<string, ProfileExtrusionDescriptor> = {};

  for (const profileId in profiles) {
    profileTable[profileId] = profileEntityToDescriptor(profiles[profileId]);
  }

  return profileTable;
}
